/**
 * US-A3 — shown when a request hits a `401` that a silent `/auth/refresh` could not fix
 * (the refresh token itself expired, i.e. the absolute session ceiling was reached).
 * Reloading re-runs the iframe handshake (the parent re-mints the `?t=` token, §8).
 */
export function ReloadPrompt() {
  return (
    <div className="modal-backdrop" role="alertdialog" aria-labelledby="reload-title">
      <div className="state-card">
        <h1 id="reload-title">Session expired</h1>
        <p>Your session has timed out. Reload to continue where you left off.</p>
        <button type="button" className="btn primary" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    </div>
  );
}
